module.exports = __webpack_public_path__ + "static/media/Phonic_Logo_4x.b5efc787.png";